"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
function ResponsiveHeader(_a) {
    var _b;
    var isAuthenticated = _a.isAuthenticated, currentLocale = _a.currentLocale;
    var theme = (0, material_1.useTheme)();
    var isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down(320));
    var _c = (0, react_1.useState)(false), isMenuOpen = _c[0], setIsMenuOpen = _c[1];
    var activeTab = (_b = document.getElementById('responsive-header')) === null || _b === void 0 ? void 0 : _b.dataset.activeTab;
    var isActive = function (tab) {
        return tab == activeTab;
    };
    var toggleDrawer = function (isOpen) { return function (event) {
        if (event.type === 'keydown' &&
            (event.key === 'Tab' ||
                event.key === 'Shift')) {
            return;
        }
        setIsMenuOpen(isOpen);
    }; };
    var handleMenuClick = function (event) {
        // @ts-ignore — setAnchorEl intentionally preserved from original (anchorEl state not declared)
        setAnchorEl(event.currentTarget);
    };
    var toggleActive = function (event) {
        event.target instanceof HTMLElement && event.target.classList.toggle('active');
    };
    var handleMenuClose = function () {
        // @ts-ignore — setAnchorEl intentionally preserved from original (anchorEl state not declared)
        setAnchorEl(null);
    };
    var navLinks = [
        { title: (0, Lang_js_1.__)('Ministers'), path: '/app/ministry/recordings/', tab: 'ministry' },
        { title: (0, Lang_js_1.__)('Initiates'), path: '/app/initiate/broadcasts', tab: 'initiate' },
        { title: (0, Lang_js_1.__)('Seminar Leaders'), path: '/app/seminar-leader/articles', tab: 'seminar-leader' },
        // { title: __('Subscriptions'), path: '/app/subscriptions/manage', tab: 'subscriptions-manage'}, // hidden for testing
        { title: (0, Lang_js_1.__)('Student Download Center'), path: '/app/downloads', tab: 'student-downloads' },
        //  { title: __('Account'), path: currentLocale === 'es' ? '/tienda/my-account/edit-address/' : '/shop/my-account/', tab: 'account' },
    ];
    var navLinksMobile = [
        { title: (0, Lang_js_1.__)('Ministers'), path: '/app/ministry/recordings/', tab: 'ministry' },
        { title: (0, Lang_js_1.__)('Initiates'), path: '/app/initiate/broadcasts', tab: 'initiate' },
        { title: (0, Lang_js_1.__)('Seminars'), path: '/app/seminar-leader/articles', tab: 'seminar-leader' },
        // { title: __('Subscriptions'), path: '/app/subscriptions/manage', tab: 'subscriptions-manage'}, // hidden for testing
        { title: (0, Lang_js_1.__)('Downloads'), path: '/app/downloads', tab: 'student-downloads' },
        {
            title: (0, Lang_js_1.__)('Account'),
            path: currentLocale === 'es' ? '/tienda/my-account/edit-address/' : '/shop/my-account/',
            tab: 'account',
        },
    ];
    return (react_1.default.createElement(material_1.AppBar, { position: "static", sx: { backgroundColor: '#152041', border: 'none' } },
        react_1.default.createElement(material_1.Toolbar, { sx: {
                display: 'flex',
                justifyContent: isMobile ? 'flex-start' : 'space-between',
            } }, isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Box, { onClick: handleMenuClick, sx: { cursor: 'pointer' } }, (0, Lang_js_1.__)('Dashboard Menu')),
            "\u00A0\u00A0",
            react_1.default.createElement(material_1.IconButton, { edge: "start", color: "inherit", "aria-label": "menu", onClick: toggleDrawer(true) },
                react_1.default.createElement(Menu_1.default, null)),
            react_1.default.createElement(material_1.Drawer, { anchor: "right", open: isMenuOpen, onClose: toggleDrawer(false) },
                react_1.default.createElement(material_1.List, null, navLinksMobile.map(function (link, index) { return (react_1.default.createElement(material_1.ListItem, { button: true, key: index, onClick: toggleDrawer(false), className: isActive(link.tab)
                        ? 'student-2023-button active'
                        : 'student-2023-button' },
                    react_1.default.createElement(material_1.Box, { component: "a", href: link.path, sx: {
                            textDecoration: 'none',
                            color: 'inherit',
                            width: '100%',
                        } },
                        react_1.default.createElement(material_1.ListItemText, { primary: link.title })))); }))))) : (react_1.default.createElement(material_1.Box, { className: "container-student-buttons-responsive-internal" }, navLinks.map(function (link, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(material_1.Box, { className: isActive(link.tab)
                    ? 'student-2023-button active'
                    : 'student-2023-button' },
                react_1.default.createElement(material_1.Link, { href: link.path, color: "inherit", underline: "none" }, link.title)),
            index < navLinks.length - 1 && (react_1.default.createElement(material_1.Box, { className: "line-student-buttons" })))); }))))));
}
document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('responsive-header');
    if (container) {
        (0, mountIsland_1.mountIsland)(container, react_1.default.createElement(ResponsiveHeader, { currentLocale: "en" }));
    }
});
